module.exports = __webpack_public_path__ + "img/bank-akbank.6e8732be.svg";